import React, { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import SinPermisos from "./../components/sinpermisos";
import Nav from "react-bootstrap/Nav";
import { CSVLink } from "react-csv";

const url = "https://api.mrcirp.com/public/leads";
const urldelete = "https://api.mrcirp.com/public/usuariosdelete";
const urleditar = "https://api.mrcirp.com/public/usuariosedit";

const Leadstodos = () => {
  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    id: "",
    usuario: "",
    descripcion: "",
    urlvideo: "",
    urlVideoProducto1: "",
    urlVideoProducto2: "",
    urlVideoProducto3: "",
    urlNegocio1: "",
    urlNegocio2: "",
    urlNegocio3: "",
    urlComoUnirseCliente: "",
    urlComoAfiliarse: "",
    fecha: "",
  });

  /////////////////Datatable/////////////////////////////////

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  const [pending, setPending] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setData(data);
      setPending(false);
    }, 100);
    return () => clearTimeout(timeout);
  });

  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: "Nombre",
      selector: (row) => row.nombre,
    },
    {
      name: "Correo",
      selector: (row) => row.correo,
    },
    {
      name: "telefono",
      selector: (row) => row.telefono,
    },
    {
      name: "Fecha",
      selector: (row) => row.fecha,
    },
    {
      name: "Campaña",
      selector: (row) => row.usuario,
    }
  ];

  /////////////Buscar datos//////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line
    const result = data.filter((resultdata) => {
      if (
        resultdata.nombre.toLowerCase().match(buscar.toLowerCase()) ||
        resultdata.correo.toLowerCase().match(buscar.toLowerCase()) ||
        resultdata.usuario.toLowerCase().match(buscar.toLowerCase())
      ) {
        return resultdata;
      }
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  ///////////////Insertar Datos//////////////////////////////////

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatosSeleccionados((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [Error, setError] = useState(false);

  /*   const peticionPost = async () => {
    delete datosSeleccionados.id;
    console.log(datosSeleccionados);
    await axios.post(url, datosSeleccionados).then(res => {
      peticionGet();
      setError(false);
     
    })
      .catch((err) => {
        setError(true);
        
      })
  }
 */
  //////////////Editar datos/////////////////////////////////////
  const [modalEditar, setModalEditar] = useState(false);
  const abrirModalEditar = () => {
    setModalEditar(true);
  };

  const peticionPut = async () => {
    // eslint-disable-next-line no-template-curly-in-string
    await axios
      .delete(urldelete + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        peticionGet();
        setError(false);
        setModalEditar(false);
      })
      .catch((err) => {
        setError(true);
        setModalEditar(false);
      });
  };

  const [modalEditaruser, setModalEditaruser] = useState(false);
  const abrirModalEditaruser = () => {
    setModalEditaruser(true);
  };

  const peticionPutuser = async () => {
    console.log(datosSeleccionados);
    await axios
      .put(urleditar + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        peticionGet();
        setError(false);
        setModalEditaruser(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalEditaruser(false);
      });
  };

  /////////////Mostrar datos//////////////////////////////////
  const peticionGet = async () => {
    await axios.get(url).then((response) => {
      setData(response.data);
      setFiltroBuscar(response.data);
      console.log(data);
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (users.id) {
      await peticionGet();
    }
  }, [users.id]);

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "admin") {
      return (
        <div>
          <div className="Categorias">
            <Sidebar>
              <Card>
                <Card.Header className="bg-dark text-white" as="h3">
                  <div className="row">
                    <div className="col-md-12">Leads captados</div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Card.Title> Leads registrado</Card.Title>
                  {Error && (
                    <div className="alert alert-danger">
                      {
                        <strong>
                          Error: El nombre ya existe! intente con otro nombre.
                        </strong>
                      }
                    </div>
                  )}
                  <p> Leads registrado en el sistema.</p>
                  <div className="d-flex  mb-3">
                    <CSVLink
                      data={filtrobuscar}
                      filename={"leads.csv"}
                      className="btn btn-primary"
                      target="_blank"
                    >
                      Descargar CSV
                    </CSVLink>
                  </div>
                  <DataTable
                    columns={columns}
                    data={filtrobuscar}
                    noDataComponent="Cargando..."
                    progressPending={pending}
                    progressComponent={<Cargando />}
                    pagination
                    paginationComponentOptions={paginationComponentOptions}
                    subHeader
                    subHeaderComponent={
                      <input
                        type="text"
                        placeholder="Buscar Campaña"
                        className="w-25 form-control"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                      />
                    }
                  />

                  <Modal isOpen={modalEditar}>
                    <ModalHeader>
                      <div>
                        <h4>Eliminar usuario </h4>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <input
                        className="form-control"
                        readOnly
                        type="hidden"
                        name="id"
                        value={datosSeleccionados.id}
                        onChange={onchange}
                      />
                      <div className="form-group">
                        <h5>
                          ¿Desea eliminar al usuario #{datosSeleccionados.id}?{" "}
                        </h5>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalEditar(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => peticionPut()}
                      >
                        Eliminar
                      </button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={modalEditaruser}>
                    <ModalHeader>
                      <div>
                        <h5>Editar usuario {datosSeleccionados.username}</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="form-group">
                        <input
                          className="form-control"
                          readOnly
                          type="hidden"
                          name="id"
                          value={datosSeleccionados.id}
                          onChange={handleChange}
                        />

                        <label>Descripcion</label>
                        <textarea
                          className="form-control"
                          name="descripcion"
                          value={datosSeleccionados.descripcion}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL video</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlvideo"
                          value={datosSeleccionados.urlvideo}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL video producto 1</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlVideoProducto1"
                          value={datosSeleccionados.urlvideoproducto1}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL video producto 2</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlVideoProducto2"
                          value={datosSeleccionados.urlvideoproducto2}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL video producto 3</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlVideoProducto3"
                          value={datosSeleccionados.urlvideoproducto3}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL negocio 1</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlNegocio1"
                          value={datosSeleccionados.urlnegocio1}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL negocio 2</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlNegocio2"
                          value={datosSeleccionados.urlnegocio2}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL negocio 3</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlNegocio3"
                          value={datosSeleccionados.urlnegocio3}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL como unirse como cliente</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlComoUnirseCliente"
                          value={datosSeleccionados.urlcomounirsecliente}
                          onChange={handleChange}
                        />
                        <br />
                        <br />
                        <label>URL como afiliarse</label>
                        <input
                          className="form-control"
                          type="text"
                          name="urlComoAfiliarse"
                          value={datosSeleccionados.urlcomoafiliarse}
                          onChange={handleChange}
                        />
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalEditaruser(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={() => peticionPutuser()}
                      >
                        Actualizar
                      </button>
                    </ModalFooter>
                  </Modal>
                </Card.Body>
              </Card>
            </Sidebar>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  } else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Leadstodos;